import { extend, localize } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import nl from "vee-validate/dist/locale/nl.json";
import moment from "moment";

const installedRules = [];

// with typescript
for (let i = 0; i < Object.entries(rules).length; i += 1) {
  const [rule, validation] = Object.entries(rules)[i];
  installedRules.push(rule);
  extend(rule, {
    ...validation,
  });
}

extend("nullable", () => true);
installedRules.push("nullable");

extend("date", (value) => moment(value).isValid());
installedRules.push("date");

// Selecteer nederlandse vertaling
localize("nl", {
  ...nl,
  ...{
    messages: {
      required: "Dit veld is verplicht",
    },
    fields: {
      selectie: {
        required: "Je dient een selectie op te geven.",
      },
    },
  },
});

export default installedRules;
